import React, { useEffect, useState } from "react";
import "../CSS/navbar.css";
import home from "../Images/navbar/homeicon.png";
import educationimg from "../Images/navbar/education.png";
import skillsicon from "../Images/navbar/skills.png";
import projectsimg from "../Images/navbar/projects.png";
import certificationimg from "../Images/navbar/certifications.png";
import contactdetailsimg from "../Images/navbar/contactdetails.png";
import homeg from "../Images/navbar/homeicon-green.png";
import educationimgg from "../Images/navbar/education-green.png";
import skillsicong from "../Images/navbar/skills-green.png";
import projectsimgg from "../Images/navbar/projects-green.png";
import certificationimgg from "../Images/navbar/certifications-green.png";
import contactdetailsimgg from "../Images/navbar/contactdetails-green.png";
import sidebaricon from "../Images/sidebar.png";

function Navbar({ index, setsidebarstatus }) {
  const [curindex, setcur] = useState(index);
  const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
      const mediaQuery = window.matchMedia(query);

      const handleMediaChange = (event) => {
        setMatches(event.matches);
      };

      mediaQuery.addListener(handleMediaChange);
      setMatches(mediaQuery.matches);

      return () => {
        mediaQuery.removeListener(handleMediaChange);
      };
    }, [query]);

    return matches;
  };
  const ismobileScreen = useMediaQuery("(max-width: 1470px)");
  useEffect(() => {
    setcur(index);
  }, [index]);
  return (
    <div className="navbar-container">
      {ismobileScreen ? (
        <div
          onClick={() => {
            setsidebarstatus(true);
          }}
        >
          <img clas src={sidebaricon} alt="opensidebar" />
        </div>
      ) : (
        ""
      )}
      <div className="navbar">
        <img src={curindex === 0 ? homeg : home} alt="introduction" />
        <img
          src={curindex === 1 ? educationimgg : educationimg}
          alt="education"
        />
        <img src={curindex === 2 ? skillsicong : skillsicon} alt="skills" />
        <img src={curindex === 3 ? projectsimgg : projectsimg} alt="projects" />
        <img
          src={curindex === 4 ? certificationimgg : certificationimg}
          alt="Certificaitons"
        />
        <img
          src={curindex === 5 ? contactdetailsimgg : contactdetailsimg}
          alt="Contactme"
        />
      </div>
    </div>
  );
}
export default Navbar;
